import React, { FC, Key, useEffect, useState } from 'react'
import './TaxUpdate.scss'

import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import state from 'Data/stateNG.json'
import Swal from 'sweetalert2'
import profileService from 'Services/profileService'

interface propsType {
  toggleModal: () => void
  profile: any
  setProfile: any
}

export type taxUpdate = {
  taxId: string
  state: string
}

const schema = yup.object().shape({
  taxId: yup.string().required('Field is required'),
  state: yup.string().required('Field is required'),
})

const TaxUpdate: FC<propsType> = ({ profile, setProfile, toggleModal }) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<taxUpdate>({
    resolver: yupResolver(schema),
  })

  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  useEffect(() => {
    if (profile) {
      reset({
        taxId: profile?.taxId === null || profile?.taxId === 'string' ? '' : profile?.taxId,
        state: profile?.state === null || profile?.state === 'string' ? '' : profile?.state,
      })
    }
  }, [profile, reset])

  const submitNewUserInformation = handleSubmit(async (data: taxUpdate) => {
    await profileService
      .updateProfileV2({
        taxId: data.taxId,
        state: data.state,
      })
      .then(
        (res: any) => {
          setRequest(false)
          Swal.fire({
            text: 'Employment information update request sent succesfully',
            icon: 'success',
            confirmButtonText: 'Ok',
          })
          if (res.data.status === true) {
            setProfile((prev: any) => ({
              ...prev,
              ...data,
            }))
          } else {
            const swalWithBootstrapButtons = Swal.mixin({
              customClass: {
                cancelButton: 'btn btn-danger',
              },
              buttonsStyling: false,
            })

            swalWithBootstrapButtons.fire({
              title: 'Oops!',
              text: 'Something went wrong!',
              icon: 'warning',
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: 'close',
              reverseButtons: true,
            })
          }

          toggleModal()
        },
        (error: { response: { data: { error: string } } }) => {
          console.log(error)
          setRequest(false)
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              cancelButton: 'btn btn-danger',
            },
            buttonsStyling: false,
          })

          swalWithBootstrapButtons.fire({
            title: 'Oops!',
            text: error.response.data.error,
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: 'close',
            reverseButtons: true,
          })
        },
      )
  })
  return (
    <div className='tax-update'>
      <form action='/product-scanner'>
        <div className='form-group mb-3'>
          <label htmlFor='price-per-lit'>Tax ID</label>
          <input
            placeholder='Tax ID'
            type='text'
            id='taxId'
            className='form-control'
            {...register('taxId')}
          />
          {errors.taxId && <div className='text-danger'>{errors.taxId.message}</div>}
        </div>

        <div className='form-group mb-3'>
          <label htmlFor='state'>Residential State</label>
          <select id='state' defaultValue='' className='form-control' {...register('state')}>
            <option disabled value=''>
              --Select State--
            </option>
            {state.map((state: { name: string }, index: Key) => {
              return <option key={index}>{state.name}</option>
            })}
          </select>
          {errors.state && <div className='text-danger'>{errors.state.message}</div>}
        </div>
        <div className='form-group'>
          <button
            className='btn btn-default-2 w-100'
            onClick={(e) => submitNewUserInformation(e)}
            disabled={request}
          >
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default TaxUpdate
